import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Legacy /payment route — kept alive for old in-app links.
 * As of Stage E (Feb 2026) all paywall traffic flows through /app/pricing,
 * which presents the three Square subscription tiers (Basic / Premium / Premium Plus).
 */
export default function Payment() {
  const navigate = useNavigate();
  useEffect(() => {
    navigate("/app/pricing", { replace: true });
  }, [navigate]);
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center" data-testid="payment-redirect">
        <div className="w-10 h-10 border-4 border-purple-600 border-t-transparent rounded-full animate-spin mx-auto" />
        <p className="text-slate-500 font-medium mt-3 text-sm">Taking you to pricing…</p>
      </div>
    </div>
  );
}
